import Vue from 'vue';
import VueRouter from 'vue-router';

import { routes } from './routes';
import store from './stores/store';
import './assets/styles/app.scss'
//import { firebaseListener } from './config/firebaseConfig';

import App from './App.vue';

Vue.use(VueRouter);

import VueHtmlToPaper from 'vue-html-to-paper'
Vue.use(VueHtmlToPaper)

//firebaseListener(authStatusChange);
// onAuthStateChanged(firebaseAuth, user => {
// 	if (store) {
// 		store.commit('AUTH_STATUS_CHANGE');
// 	}
// 	// Check for user status
// });

const router = new VueRouter({
	mode: 'history',
	routes
});

// router.beforeEach((to, from, next) => {
//     if (to.onlyGuest && store.getters.isLoggedIn) {
//         next('/');
//     } else {
//         next();
//     }
// });


new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

// function authStatusChange(loggedIn, user) {
// 	if (store) {
// 		store.commit('AUTH_STATUS_CHANGE');

// 		if (user) {
// 		// 	store.dispatch('getShoppingCart', {uid: user.uid, currentCart: store.getters.cartItemList});
// 		}
// 	}
// }
